// Utility to extract the "site" (subdomain) from a hostname

/**
 * Extract subdomain from hostname.
 * Examples:
 *  - dojo1.taekwondo.ar => dojo1
 *  - dojo2.taekwondo.ar => dojo2
 *  - localhost => null
 *  - 127.0.0.1 => null
 *
 * @param {string} hostname
 * @returns {string|null} subdomain or null when not present
 */
export function getSiteFromHostname(hostname) {
  if (!hostname || typeof hostname !== 'string') return null;

  // Exclude localhost and IPv4 loopback addresses
  if (
    hostname === 'localhost' ||
    hostname === '[::1]' ||
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(hostname)
  ) {
    return null;
  }

  const parts = hostname.split('.');
  // If hostname is like "sub.domain.tld" (3+ parts), consider the first part a subdomain
  if (parts.length >= 3) {
    const first = parts[0];
    // Avoid returning common prefixes like 'www'
    if (first && first.toLowerCase() !== 'www') {
      return first;
    }
  }

  return null;
}

export default getSiteFromHostname;

